import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaCloudUploadAlt } from "react-icons/fa";
import Background from './Background';
import { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import { ToastContainer, toast } from 'react-toastify';

function AddBackgroundImage() {
    const history = useHistory();
    const [cookies] = useCookies(['user']);
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageUrl, setImageUrl] = useState("");
    const [siteUrl, setSiteUrl] = useState("");
    const [enabled, setEnabled] = useState(true);
    const [opacity, setOpacity] = useState(0.15);
    const [isLoading, setIsLoading] = useState(false);

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            setImageFile(file);
            setImageUrl("");
            const reader = new FileReader();
            reader.onload = (e) => setImagePreview(e.target.result);
            reader.readAsDataURL(file);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { 'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp'] },
        maxFiles: 1
    });

    const createBackgroundImageAPI = () => {
        if (!imageFile && (!imageUrl || !imageUrl.trim())) {
            toast.error("Please upload an image or enter an image URL");
            return;
        }
        if (opacity < 0 || opacity > 1) {
            toast.error("Opacity must be between 0 and 1");
            return;
        }

        var data = new FormData();
        if (imageFile) {
            data.append("image", imageFile);
        } else {
            data.append("image_url", imageUrl.trim());
        }
        if (siteUrl && siteUrl.trim()) {
            data.append("site_url", siteUrl.trim());
        }
        data.append("enabled", enabled ? "1" : "0");
        data.append("opacity", String(opacity));

        setIsLoading(true);
        fetch('https://api.connecker.com/api/create_background_image', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code == 200) {
                toast.success(data.message);
                setTimeout(() => {
                    history.push('/background_images');
                }, 1000);
            } else {
                toast.error(data.message || 'Failed to create background image');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to create background image');
        });
    }

    return(
        <div className="content">
            <div className="row d-flex justify-content-center">
                <div className="col-2 col-sm-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 style={{ color:"white", marginTop:"50px" }}>Add Background Image</h4>
                    <div className="card" style={{width:"100%"}}>
                        <div className="card-body">
                            <div className="d-flex">
                                <h6 style={{ color:"orange" }}>Basic</h6>
                                &nbsp;
                                <h6>Information</h6>
                            </div>
                            <br></br>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>Image * (upload or enter URL)</label>
                                    {imagePreview && (
                                        <div className="mb-2">
                                            <img 
                                                src={imagePreview} 
                                                alt="Preview" 
                                                style={{ width: "200px", height: "120px", objectFit: "cover", borderRadius: "8px", border: "1px solid #ddd" }}
                                            />
                                            <button 
                                                type="button" 
                                                className="btn btn-sm btn-outline-secondary ms-2"
                                                onClick={() => { setImageFile(null); setImagePreview(null); }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    )}
                                    {!imagePreview && (
                                        <div {...getRootProps()} className="border rounded p-4 text-center" style={{ borderColor: "lightgrey", cursor: "pointer", backgroundColor: "#fafafa" }}>
                                            <input {...getInputProps()} />
                                            <FaCloudUploadAlt style={{ width: "3rem", height: "3rem", color: "#FF4500" }} />
                                            <p className="mb-0 mt-2" style={{ color: "#666" }}>{isDragActive ? "Drop the image here" : "Drag & drop or click to upload"}</p>
                                            <p className="mb-0 mt-1" style={{ fontSize: "12px", color: "#999" }}>JPEG, PNG, GIF, WebP (max 10MB)</p>
                                        </div>
                                    )}
                                    <div className="mt-2">
                                        <span style={{ fontSize: "12px", color: "#666" }}>— or —</span>
                                    </div>
                                    <input 
                                        type="url" 
                                        className="form-control mt-2" 
                                        style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} 
                                        placeholder="https://example.com/image.jpg"
                                        value={imageUrl}
                                        onChange={(e) => { setImageUrl(e.target.value); if (imageFile) { setImageFile(null); setImagePreview(null); } }}
                                        disabled={!!imageFile}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>Site URL (optional)</label>
                                    <input 
                                        type="url" 
                                        className="form-control" 
                                        style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} 
                                        placeholder="https://example.com"
                                        value={siteUrl}
                                        onChange={(e) => setSiteUrl(e.target.value)} 
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>Opacity (0–1)</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }} 
                                        step="0.01"
                                        min="0"
                                        max="1"
                                        value={opacity}
                                        onChange={(e) => setOpacity(parseFloat(e.target.value) || 0.15)} 
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={{ fontSize: "13px", color: "#666" }}>Enabled</label>
                                    <select
                                        className="form-select"
                                        style={{ border:"1px solid lightgrey", borderRadius:"8px", padding:"10px" }}
                                        value={enabled ? 1 : 0}
                                        onChange={(e) => setEnabled(e.target.value === '1')}
                                    >
                                        <option value={1}>Enabled</option>
                                        <option value={0}>Disabled</option>
                                    </select>
                                </div>
                                <div className="col-12">
                                    <button 
                                        onClick={() => createBackgroundImageAPI()} 
                                        disabled={isLoading}
                                        style={{ 
                                            color:"white", 
                                            backgroundColor:"#FF4500", 
                                            border:"1px solid #FF4500", 
                                            borderRadius:"8px", 
                                            padding:"10px 32px",
                                            opacity: isLoading ? 0.6 : 1,
                                            cursor: isLoading ? "not-allowed" : "pointer"
                                        }}
                                    >
                                        {isLoading ? 'Submitting...' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AddBackgroundImage;
